export default "/images/1a9f128cca6fbb5b344d068704414420.avif";